import { BRAND } from '@/config/brand.generated'

export type TeamOption = {
  name: string
  plan: string
  logo: string
  mode: 'demo' | 'real'
}

export type SidebarUser = {
  name: string
  email: string
}

const senseiLogo = '/sensei-logo-white.png'

export const teamOptionsMock: TeamOption[] = [
  {
    name: BRAND.appName,
    plan: 'Real Data',
    logo: senseiLogo,
    mode: 'real',
  },
  {
    name: BRAND.appName,
    plan: 'Demo Data',
    logo: senseiLogo,
    mode: 'demo',
  },
]

export const sidebarUserMock: SidebarUser = {
  name: `${BRAND.appName} Kullanıcısı`,
  email: 'ops@senseiverse.ai',
}
